// ════════════════════════════════════════════════════════════════════════════
// 📳 Haptics — Phase 2.5 Tactile feedback via Vibration API
// ════════════════════════════════════════════════════════════════════════════
// Thin wrapper around navigator.vibrate() with a user-configurable toggle.
// Setting is persisted in localStorage under 'kangavena_haptics'.
// No-ops gracefully on desktops & iOS Safari (no vibration API).
// ════════════════════════════════════════════════════════════════════════════

const STORAGE_KEY = 'kangavena_haptics';

type Pattern = 'tap' | 'success' | 'warn' | 'error' | 'scan';

const patterns: Record<Pattern, number | number[]> = {
  tap:     12,
  scan:    [0, 20, 30, 20],
  success: [0, 15, 40, 25],
  warn:    [0, 30, 50, 30],
  error:   [0, 60, 40, 60, 40, 60],
};

function canVibrate(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
}

function isEnabled(): boolean {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    // Default: enabled. Disable explicitly by setting "0".
    return v === null ? true : v === '1';
  } catch { return true; }
}

export const Haptics = {
  fire(pattern: Pattern) {
    if (!canVibrate() || !isEnabled()) return;
    try { navigator.vibrate(patterns[pattern]); } catch { /* silent */ }
  },

  isEnabled,

  setEnabled(on: boolean) {
    try { localStorage.setItem(STORAGE_KEY, on ? '1' : '0'); } catch { /* silent */ }
  },

  isSupported: canVibrate,
};
